import React from "react";
import List from "./List";

const App = () => {
  return <List />;
};

export default App;
